import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSwitch } from "@redotech/redo-web/switch";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const freightSettingsForm = groupInput({
  freightEnabled: input<boolean>(),
  spreadPercentage: input<number>(),
});

export type FreightSettingsForm = InputSchema.Input<typeof freightSettingsForm>;

export type FreightSettingsValue = InputSchema.Value<
  typeof freightSettingsForm
>;

export const freightSettingsDefault: FreightSettingsValue = {
  freightEnabled: true,
  spreadPercentage: 12,
};

export const FreightSettingsCard = memo(function FreightSettingsCard({
  input,
  isOmsEngineer,
}: {
  input: OutboundLabelForm;
  isOmsEngineer: boolean;
}) {
  const { freightSettings } = input.inputs;

  return (
    <Card title="Freight Settings" w="full">
      <Flex dir="column" gap="md">
        <FormSwitch
          input={freightSettings.inputs.freightEnabled}
          label="Enable Freight"
        />
        <RedoIncrementDecrement
          disabled={!isOmsEngineer}
          label="Spread Percentage"
          min={0}
          setValue={freightSettings.inputs.spreadPercentage.setValue}
          step={1}
          value={freightSettings.value.spreadPercentage}
        />
      </Flex>
    </Card>
  );
});
